<action-box *ngIf="visible" textLeft="{{actionBoxTitle}}" [showHeader]="showHeader">
  <div *ngFor="let document of documentValues" class="py-2" title="{{document.title}}">
    <documents-link [document]="document" [confSessionId]="storeSession.confSessionId" [activeConfigurationId]="storeSession.activeConfigurationId"></documents-link>
  </div>
</action-box>